import React, { useEffect } from 'react'
import { CUSTOM_EVENT_NAME } from '@typesApp/AppEvent'
import { useAppEventListener } from '@connector/hooks/useAppEventListener'
import { useInitialConfiguration } from '@hooks/useInitialConfiguration'
import { useAnalytics } from '@hooks/useAnalytics'

/**
 * App used internally for intialization
 */
export const InitializerApp: React.FC = () => {
  const appEventListener = useAppEventListener()

  useAnalytics()
  useInitialConfiguration()

  useEffect(() => {
    document.addEventListener(CUSTOM_EVENT_NAME.APP, appEventListener)
    return () => {
      document.removeEventListener(CUSTOM_EVENT_NAME.APP, appEventListener)
    }
  }, [appEventListener])

  return null
}
